import { render, staticRenderFns } from "./sub-units.vue?vue&type=template&id=5c9f5774&scoped=true&"
import script from "./sub-units.vue?vue&type=script&lang=ts&"
export * from "./sub-units.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9f5774",
  null
  
)

export default component.exports